import { getEvalsPageApi, getEvalTotalByExpertIdApi } from '@services/Experts';
import { conferenceTypes } from '@utils/constants';
import { convertDateTimeRangeToLocalText } from '@utils/utils';
import { Button, Col, Dropdown, Form, Input, Layout, Row, Space, Spin, Table, Tag, Tooltip, Typography } from 'antd';
import * as echarts from 'echarts';
import { isEmpty } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { filterFormGridLayout, filterFormItemLayout, fullPagerConfig } from '@/utils/property';
import EvaluationCheckDrawer from '../../evaluation/components/EvaluationCheckDrawer';
import './index.less';

const { Content } = Layout;
const { Link, Text } = Typography;

const Evaluation = props => {
    const { expertId } = props;

    const [filter, setFilter] = useState({
        page: 1,
        pageSize: 10,
        sortType: 1,
        expertId,
    });

    // 渲染table数据的state
    const [tableData, setTableData] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [visibleEvaluationCheckDrawer, setVisibleEvaluationCheckDrawer] = useState(false);
    const [currentEvaluation, setCurrentEvaluation] = useState({}); // 当条专家信息
    const [evalTotal, setEvalTotal] = useState({}); // 专家综评信息

    const [form] = Form.useForm();

    // echarts 图表引用
    const friendRadarRef = useRef(null);
    const professionRadarRef = useRef(null);
    const friendChartRef = useRef(null);
    const professionChartRef = useRef(null);

    const onFinish = values => {
        console.log(values);
        handleFilterFinish(values);
    };

    const onReset = () => {
        form.resetFields();

        setFilter({
            page: 1,
            pageSize: filter.pageSize,
            sortType: 1,
            expertId: expertId,
        });
    };

    useEffect(() => {
        form.setFieldsValue(filter);
    });

    // 筛选数据
    const handleFilterFinish = values => {
        const newFilter = {
            ...filter,
            ...values,
            page: 1,
        };

        Object.keys(newFilter).forEach(key => {
            if (!newFilter[key]) {
                delete newFilter[key];
            }
        });

        // console.log('newfilter', newFilter);
        setFilter(newFilter);
    };

    // 排序下拉菜单
    const onClickDropdown = ({ key }) => {
        setFilter({ ...filter, sortType: Number(key) + 1 });
    };

    // 刷新
    const handleRefresh = () => {
        getExpertList();
    };

    const onChangePage = (page, pageSize) => {
        setFilter({
            ...filter,
            page,
            pageSize,
        });
    };

    // 切换特殊说明展开收起状态
    const toggleRemarksExpansion = record => {
        const recordKey = `${record.expertId}_${record.agendaId}`;
        const newTableData = tableData.map(item => {
            const itemKey = `${item.expertId}_${item.agendaId}`;
            if (itemKey === recordKey) {
                return { ...item, remarksExpanded: !item.remarksExpanded };
            }
            return item;
        });
        setTableData(newTableData);
    };

    // 获取专家综评分数
    const getEvalTotalByExpertId = async () => {
        setLoading(true);
        const res = await getEvalTotalByExpertIdApi({ expertId });
        if (res && res.status_code === 200 && res.data) {
            const data = res.data;

            if (data.friendlinessTotal && !isEmpty(data.friendlinessTotal)) {
                const friendText = [],
                    friendScore = [];
                Object.keys(data.friendlinessTotal).forEach(key => {
                    friendText.push({ name: key, max: 5 });
                    friendScore.push(data.friendlinessTotal[key]);
                });
                data.friendRadarOption = {
                    color: ['#096dd9'],
                    radar: {
                        indicator: friendText,
                        radius: '65%',
                        splitNumber: 5,
                        axisName: {
                            color: '#333',
                            fontSize: 12,
                            // formatter: (val) => (val.length > 5 ? val.slice(0, 4) + '…' : val),
                        },
                        splitArea: {
                            areaStyle: {
                                color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
                            },
                        },
                    },
                    series: [
                        {
                            type: 'radar',
                            data: [
                                {
                                    value: friendScore,
                                    name: '合作友好度评分',
                                    areaStyle: {
                                        color: 'rgba(84,112,198,0.3)',
                                    },
                                    lineStyle: {
                                        width: 2,
                                    },
                                },
                            ],
                        },
                    ],
                    tooltip: {
                        trigger: 'item',
                        formatter: ({ marker, name, value }) => {
                            const lines = friendText.map((i, idx) => `${i.name}: ${value[idx]}分`);
                            return `${marker} ${name}<br/>${lines.join('<br/>')}`;
                        },
                    },
                };
            }

            if (data.professionScoreTotal && !isEmpty(data.professionScoreTotal)) {
                const professionText = [],
                    professionScore = [];
                Object.keys(data.professionScoreTotal).forEach(key => {
                    professionText.push({ name: key, max: 5 });
                    professionScore.push(data.professionScoreTotal[key]);
                });
                data.professionRadarOption = {
                    color: ['#096dd9'],
                    radar: {
                        indicator: professionText,
                        radius: '65%',
                        splitNumber: 5,
                        axisName: {
                            color: '#333',
                            fontSize: 12,
                            // formatter: (val) => (val.length > 5 ? val.slice(0, 4) + '…' : val),
                        },
                        splitArea: {
                            areaStyle: {
                                color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
                            },
                        },
                    },
                    series: [
                        {
                            type: 'radar',
                            data: [
                                {
                                    value: professionScore,
                                    name: '报告专业度评分',
                                    areaStyle: {
                                        color: 'rgba(84,112,198,0.3)',
                                    },
                                    lineStyle: {
                                        width: 2,
                                    },
                                },
                            ],
                        },
                    ],
                    tooltip: {
                        trigger: 'item',
                        formatter: ({ marker, name, value }) => {
                            const lines = professionText.map((i, idx) => `${i.name}: ${value[idx]}分`);
                            return `${marker} ${name}<br/>${lines.join('<br/>')}`;
                        },
                    },
                };
            }

            setEvalTotal(data);
        }
    };

    // 初始化图表
    const initCharts = () => {
        if (evalTotal?.friendRadarOption && friendRadarRef.current) {
            if (friendChartRef.current) {
                friendChartRef.current.dispose();
            }
            friendChartRef.current = echarts.init(friendRadarRef.current);
            friendChartRef.current.setOption(evalTotal.friendRadarOption);
        }

        if (evalTotal?.professionRadarOption && professionRadarRef.current) {
            if (professionChartRef.current) {
                professionChartRef.current.dispose();
            }
            professionChartRef.current = echarts.init(professionRadarRef.current);
            professionChartRef.current.setOption(evalTotal.professionRadarOption);
        }
    };

    // 清理图表实例
    const disposeCharts = () => {
        if (friendChartRef.current) {
            friendChartRef.current.dispose();
            friendChartRef.current = null;
        }
        if (professionChartRef.current) {
            professionChartRef.current.dispose();
            professionChartRef.current = null;
        }
    };

    // 获取专家综评列表
    const getExpertList = async () => {
        setLoading(true);
        const res = await getEvalsPageApi(filter);
        if (res && res.status_code === 200) {
            const list = res.data.list || [];

            list.forEach((item, idx) => {
                if (!!item.remarks && item.remarks.length > 0) {
                    // 按时间倒序排序
                    item.remarks.sort((a, b) => {
                        return new Date(b.createdAt) - new Date(a.createdAt);
                    });
                }
            });

            // console.log(list, 'list');

            setTableData(list);
            setTotal(res.data.totalCount);
        }
        setLoading(false);
    };

    // 渲染table数据
    useEffect(() => {
        getExpertList();
    }, [filter]);

    useEffect(() => {
        getEvalTotalByExpertId();
    }, []);

    // 监听 evalTotal 变化，初始化图表
    useEffect(() => {
        if (evalTotal?.friendRadarOption || evalTotal?.professionRadarOption) {
            // 延迟初始化，确保 DOM 已经渲染
            setTimeout(() => {
                initCharts();
            }, 100);
        }
    }, [evalTotal]);

    // 组件卸载时清理图表实例
    useEffect(() => {
        return () => {
            disposeCharts();
        };
    }, []);

    const paginationProps = {
        ...fullPagerConfig,
        size: 'small',
        total: total,
        showTotal: () => `共${total}条`,
        current: filter.page,
        pageSize: filter.pageSize,
        onChange: onChangePage,
    };

    // table 数据相关
    const columns = [
        {
            title: '任务',
            dataIndex: 'title',
            width: 300,
            render: (_, record) => (
                <>
                    <div>
                        {record.title}{' '}
                        <Tag color="blue" style={{ marginLeft: 4, marginBottom: 10 }}>
                            {record.taskName}
                        </Tag>
                    </div>
                    <div style={{ color: 'gray', fontSize: 12 }}>{convertDateTimeRangeToLocalText(record.start_time, record.end_time, 0)}</div>
                </>
            ),
        },
        {
            title: '记录人数',
            dataIndex: 'evaluationCount',
            width: 120,
            render: (_, record) =>
                record.evaluationCount ? (
                    <span style={{ cursor: 'pointer', color: '#1890ff' }} onClick={() => checkEvaluation(record)}>
                        {record.evaluationCount}人
                    </span>
                ) : (
                    <span style={{ color: 'gray' }}>暂无记录</span>
                ),
        },
        {
            title: '专家价值',
            dataIndex: 'totalScore',
            width: 150,
            render: (_, record) =>
                record.totalScore ? (
                    <>
                        <div>合作友好度：{record.friendlinessScore}分</div>
                        <div>报告专业度：{record.professionScore}分</div>
                        <div>价值度：{record.totalScore}分</div>
                    </>
                ) : (
                    <Text type="secondary">&ndash;</Text>
                ),
        },
        {
            title: '特殊说明',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 300,
            render: (_, record) => {
                if (!!record.remarks && record.remarks.length > 0) {
                    return (
                        <div className="remarks">
                            {record.remarks.map((remark, idx) => {
                                return (
                                    <div className="remark" key={`${record.expertId}_${record.agendaId}_${idx}`} style={{ display: idx !== 0 && !record.remarksExpanded ? 'none' : '' }}>
                                        <div className="remark-extra">
                                            <span className="author">{remark.enterpriseName}</span>
                                            <span className="time">{remark.createdAt}</span>
                                        </div>
                                        <div className="remark-content">{remark.remark}</div>
                                    </div>
                                );
                            })}

                            {record.remarks.length > 1 && (
                                <div className="toggle-remarks-expansion" style={{ color: '#1890ff', cursor: 'pointer', fontSize: 12 }} onClick={() => toggleRemarksExpansion(record)}>
                                    <span className="anticon" style={{ transform: record?.remarksExpanded ? 'rotate(180deg)' : 'none' }}>
                                        <i className="bi bi-caret-down" style={{ fontSize: 12 }}></i>
                                    </span>
                                    <span>{record?.remarksExpanded ? '收起' : `展开${record.remarks.length}项`}</span>
                                </div>
                            )}
                        </div>
                    );
                } else {
                    return <Text type="secondary">&ndash;</Text>;
                }
            },
        },
        {
            title: '项目名称',
            dataIndex: 'name',
            width: 240,
            render: (_, record) => (
                <>
                    <span>{record.name}</span>
                    {!!record.projectCode && (
                        <Tag color="volcano" style={{ marginLeft: 4, marginRight: 0, padding: 2, fontSize: 10, lineHeight: '1em', verticalAlign: 'middle' }}>
                            {record.projectCode}
                        </Tag>
                    )}
                    {!!record.type && (
                        <Tag color="volcano" style={{ marginLeft: 4, marginRight: 0, padding: 2, fontSize: 10, lineHeight: '1em', verticalAlign: 'middle' }}>
                            {conferenceTypes.find(item => item.type === record.type).label}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: '项目执行',
            dataIndex: 'dates',
            width: 240,
            render: (_, record) => (
                <>
                    <div>执行日期：{record.dates.replace(/,/g, ', ') || <Text type="secondary">&ndash;</Text>}</div>
                    {!!record.place && <div>执行地点：{record.place}</div>}
                </>
            ),
        },
    ];

    // 查看记录
    const checkEvaluation = record => {
        // console.log('record', record);
        setCurrentEvaluation(record);
        setVisibleEvaluationCheckDrawer(true);
    };

    return (
        <>
            <Content className="expert-evaluation-container">
                {!!evalTotal?.totalScore && (
                    <div className="evaluation-score-box">
                        <h2>
                            价值度：{evalTotal?.totalScore}分 <span>（最高分10分，保留1位小数。）</span>
                        </h2>
                        <div className="score-echarts-box">
                            {!!evalTotal?.friendlinessScore && (
                                <div className="score-echart">
                                    {!!evalTotal?.friendRadarOption && <div ref={friendRadarRef} style={{ height: 320 }} />}
                                    <h3>合作友好度：{evalTotal?.friendlinessScore}分</h3>
                                </div>
                            )}
                            {!!evalTotal?.totalScore && (
                                <div className="score-echart">
                                    {!!evalTotal?.professionRadarOption && <div ref={professionRadarRef} style={{ height: 320 }} />}
                                    <h3>报告专业度：{evalTotal?.professionScore}分</h3>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div className="filter-form-box">
                    <Form {...filterFormItemLayout} onFinish={onFinish} form={form}>
                        <Row>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="任务" name="taskName">
                                    <Input allowClear placeholder="请输入任务关键字" />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="项目名称" name="name">
                                    <Input allowClear placeholder="项目关键字或全称" />
                                </Form.Item>
                            </Col>
                            <Col className="filter-form-buttons" {...filterFormGridLayout}>
                                <Space>
                                    <Button type="default" onClick={onReset}>
                                        重置
                                    </Button>
                                    <Button type="primary" icon={<i className="bi bi-search"></i>} htmlType="submit">
                                        检索
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form>
                </div>

                <div className="main-content-body">
                    <div className="main-toolbar">
                        <div className="main-tools"></div>
                        <div className="sub-tools">
                            <Space>
                                <Dropdown
                                    menu={{
                                        items: [
                                            { key: 0, label: <>{filter?.sortType === 1 ? <Link>按任务时间倒序（默认）</Link> : '按任务时间倒序（默认）'}</> },
                                            { key: 1, label: <>{filter?.sortType === 2 ? <Link>按价值度从高到低</Link> : '按价值度从高到低'}</> },
                                            { key: 2, label: <>{filter?.sortType === 3 ? <Link>按合作友好度从高到低</Link> : '按合作友好度从高到低'}</> },
                                            { key: 3, label: <>{filter?.sortType === 4 ? <Link>按报告专业度从高到低</Link> : '按报告专业度从高到低'}</> },
                                        ],
                                        onClick: onClickDropdown,
                                    }}
                                >
                                    <Button
                                        type="default"
                                        className={filter?.sortType !== 1 ? 'sort-button-active' : ''}
                                        icon={
                                            <span className="anticon">
                                                <i className="bi bi-sort-down"></i>
                                            </span>
                                        }
                                        onClick={handleRefresh}
                                    />
                                </Dropdown>
                                <Tooltip title="刷新列表">
                                    <Button
                                        type="default"
                                        icon={
                                            <span className="anticon">
                                                <i className="bi bi-arrow-clockwise"></i>
                                            </span>
                                        }
                                        onClick={handleRefresh}
                                    />
                                </Tooltip>
                            </Space>
                        </div>
                    </div>

                    <Spin spinning={loading} delay={500}>
                        <Table className="enterprise-table" rowKey="id" columns={columns} dataSource={tableData} pagination={paginationProps} scroll={{ x: 1300 }} />
                    </Spin>
                </div>
            </Content>

            <EvaluationCheckDrawer visibleEvaluationCheckDrawer={visibleEvaluationCheckDrawer} setVisibleEvaluationCheckDrawer={setVisibleEvaluationCheckDrawer} currentEvaluation={currentEvaluation} />
        </>
    );
};

export default Evaluation;
